import { render } from "./CancelForm.vue?vue&type=template&id=af2a7a84"
import script from "./CancelForm.vue?vue&type=script&lang=js"
export * from "./CancelForm.vue?vue&type=script&lang=js"

import exportComponent from "/builds/infinitesoftsolutions/haz/haz-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__